import PropTypes from 'prop-types';


import {geoConstants} from '../Geo';


export const SHAPE_ADDRESS = PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    city: PropTypes.string,
    countryAlpha2: geoConstants.COUNTRY_ALPHA2_SHAPE,
    countryName: PropTypes.string,
    countryNativeName: PropTypes.string,
    name: PropTypes.string,
    nameAddition: PropTypes.string,
    postCode: PropTypes.string,
    state: PropTypes.string
});
